const messageConstant = {
  IEM001: `Username is incorrect. Please try again!`,
  IEM002: (time) => `Password is incorrect. Username will be locked after ${time} times”!`,
  IEM003: `Please fill in the required field`,
  IEM004: `The new password must be different from current password`,
  IEM005: `Passwords do not match`,
  IEM006: `The password must contain at least 8 alphanumeric characters with at least 1 uppercase and 1 special character including @$ ! % * # ? &`,
  IEM007: `Please input the correct email format`,
  IEM008: `Please select at least one product`,
  IEM009: `Last updated date (from) is exceeded Last updated date (to), please try to input again`,
  IEM010: `There’s already a role with this name`,
  IEM011: `Please upload an icon for the CVP`,
  IEM012: `The Maximum Value has to be greater than the Minimum Value`,
  IEM013: `The Step has to be greater than 0 and less than Maximum Value`,
  IEM014: `The CVP Name has already existed, please try another CVP name`,
  IEM015: `Username is locked. Please contact the Administrator`,
  IEM016: `Email already exists`,
  IEM017: `The Criteria name is existing, please try another name`,
  IEM018: (arrayIndex) => {
    const newArr = arrayIndex.map((item) => `Data Item ${item + 1}`);
    return `The ${newArr.join(', ')} is duplicated, please correct it`;
  },
  IEM019: `Please select the Last updated date (from)`,
  IEM020: `Maximum number of Responsible Parties (03) has been added`,
  IEM021: `Wrong OTP`,
  IEM022: `OTP is expired`,
  IEM023: `Maximum percentage is 999.99`,
  IEM024: `Username is inactive. Please contact the Administrator`,
  IEM025: `Username can not contain only numbers, special characters or space`,
  IEM026: `This Username does not exist. Please try again`,
  IEM027: `Please select the value`,
  IEM028: (value) => `Minimum value is ${value}`,
  IEM029: `Please update the Classified Employer List`,
  IEM030: `The employer name can contain only alphabetic character. Please try again!`,
  IEM031: (value) => `The maximum size is ${value}. Please try again!`,
  IEM032: `Please input the full mobile number`,
  IEM033: (value) => `Maximum value is ${value}`,
  IEM034: `The maximum numbers of file is 5, please remove at least one existing file if you still want to upload new file`,
  IEM035: `Upload unsuccessfully. Please try again!`,
  IEM036: `The Product Name is existing. Please try again!`,
  IEM037: `Username is locked. Please try again!`,
  IEM038: `Username is inactive. Please try again!`,
  IEM039: `Please input correct phone number!`,
  IEM040: `Please only input up to 20x your monthly income`,
  IEM041: `Please only input loan tenor from 1 to 48 months`,
  IEM042: `The File format is incorrect. Please try again!`,
  IEM043: `Please upload the artefacts!`,
  IEM044: `Please input Minimum Value or Maximum Value or both!`,
  IEM050: `Only Bank User can login`,
  IEM051: `Only Admin User can login`,
  ER001: (RoleName) => `There is already a role ${RoleName} with the same set of permissions`,
  ER002: 'The uploaded file is exceeded maximum size (2M), please try another one',
  CM001: 'Are you sure you want to logout?',
  CM002: (Object) => `Are you sure you want to update this ${Object}?`,
  CM003: (Object) => `Are you sure you want to cancel this ${Object}?`,
  CM004: (Object) => `Are you sure you want to save this ${Object}?`,
  CM005: (Object) => `Are you sure you want to deactivate this ${Object}?`,
  CM006: (Object) => `Are you sure you want to activate this ${Object}?`,
  CM007: 'Are you sure you want to save this criteria as draft?',
  IM001: `Password is changed successfully`,
  IM002: (Object, name) => `${Object} ${name} is changed successfully!`,
  IM003: (Object, name) => `${Object} ${name} is created successfully!`,
  IM004: (Object, name) => `${Object} ${name} is updated successfully!`,
  IM005: `No results found`,
  IM008: (Object) => `One Time Password has been sent to your email ${Object}`,
};
export default messageConstant;
